import React, { useEffect, useMemo, useState } from "react";
import { DataHandlerStore } from "./stores/DataHandlerStore";
import { observer } from "mobx-react";
import OrganizationBreadcrumbs, {
    BreadcrumbType,
} from "../OrganizationBreadcrumbs";

type DataSourceBreadcrumbsProps = {
    store: DataHandlerStore;
    fileType: string;
    name?: string;
};

const DataSourceBreadcrumbs: React.FC<DataSourceBreadcrumbsProps> = observer(
    ({ store, fileType, name }) => {
        const { setActiveStep, activeStep } = store;

        const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbType[]>();

        const defaultBreadcrumbs = useMemo(() => {
            return [
                {
                    label: "Data Sources",
                    onClick: () => setActiveStep(0),
                },
            ];
        }, [setActiveStep]);

        useEffect(() => {
            if (activeStep === 0) {
                setBreadcrumbs([...defaultBreadcrumbs]);
            } else if (activeStep === 1) {
                setBreadcrumbs([...defaultBreadcrumbs, { label: fileType }]);
            } else if (activeStep > 1) {
                setBreadcrumbs([
                    ...defaultBreadcrumbs,
                    { label: fileType, onClick: () => setActiveStep(1) },
                    { label: name || "New Data Source" },
                ]);
            }
        }, [activeStep, name, defaultBreadcrumbs, setActiveStep, fileType]);

        return (
            <OrganizationBreadcrumbs
                additionalBreadcrumbs={breadcrumbs}
            ></OrganizationBreadcrumbs>
        );
    },
);

export default DataSourceBreadcrumbs;
